import { Box, SimpleGrid, Skeleton, VStack } from '@chakra-ui/react'
import { GrandImage } from 'ui'
import nexiNetsImg from './nexi_nets.png'

export const NexiCheckoutSkeleton = () => {
  return (
    <VStack w="100%" gap={14} pt={6}>
      <SimpleGrid gap="14" w="100%" maxWidth={{ base: 375, md: 770 }} columns={{ base: 1, md: 2 }}>
        <VStack gap={4}>
          <Skeleton height={20} w="100%" borderRadius="xl" />
          <Skeleton height={20} w="100%" borderRadius="xl" />
        </VStack>

        <VStack gap={8}>
          <Skeleton height="400px" w="100%" borderRadius="xl" />
          <Skeleton height={14} w="100%" borderRadius="3rem" />
        </VStack>
      </SimpleGrid>

      <Box maxWidth="180px">
        <GrandImage src={nexiNetsImg} alt="Nexi Nets" />
      </Box>
    </VStack>
  )
}
